import { cellNotFilter, emptyCell, SI_NO_CHOICE } from "@/shared";
import { IDataProducto } from "@/shared/interfaces";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import InfoImgProducto from "../componente/InfoImgProducto";
import { useUiConfirmModalStore } from "@/store/ui";
import { SwitchComponente } from "@/shared/components/ui";
import { useFetchPutProducto } from "@/shared/actions/erp";

export const useTableColumnsInventariable = () => {
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  const updateProducto = useFetchPutProducto({});

  const columns = useMemo<MRT_ColumnDef<IDataProducto>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'codigo',
      size: 150,
    },
    {
      accessorKey: 'numero_referencia',
      header: 'Número referencia',
      size: 150
    },
    {
      accessorKey: 'descripcion',
      header: 'descripcion',
      size: 200,
      Cell: ({ row }) => emptyCell(row.original.descripcion)
    },
    {
      id: 'categoria_producto_nombre',
      accessorKey: 'categoria_producto',
      header: 'categoria producto',
      size: 200,
      Cell: ({ row }) => emptyCell(row.original.categoria_producto)
    },
    /* {
      accessorKey: 'subcategoria_producto',
      header: 'Subcategoria producto',
      size: 200,
      Cell: ({ row }) => emptyCell(row.original.subcategoria_producto_data?.nombre)
    }, */
    {
      ...cellNotFilter,
      accessorKey: 'proveedor',
      header: 'proveedor',
      size: 150,
      Cell: ({ row }) => row.original.proveedor_data != null
        ? row.original.proveedor_data.nombre_comercial
        : '—'
    },
    {
      ...cellNotFilter,
      accessorKey: 'presentacion',
      header: 'presentación',
      size: 150,
      Cell: ({ row }) => row.original.presentacion_data != null
        ? row.original.presentacion_data.nombre
        : '—'
    },
    {
      filterVariant: 'select',
      filterSelectOptions: ['INVENTARIABLE', 'GASTOS', 'COSTOS', 'VENTAS', 'ACTIVOS'],
      accessorKey: 'tipo_producto',
      header: 'tipo producto',
      size: 200,
      Cell: ({ row }) => emptyCell(row.original.tipo_producto)
    },
    {
      ...cellNotFilter,
      accessorKey: 'recurrencia_compra',
      header: 'recurrencia compra',
      size: 200,
      Cell: ({ row }) => emptyCell(row.original.recurrencia_compra)
    },
    {
      accessorKey: "img",
      header: "Imagen",
      size: 200,
      Cell: ({ row }) => {
        const urls = row.original.urls_imagenes?.filter(
          (url) => url && url.trim() !== ""
        );

        return urls && urls.length > 0 ? (
          <InfoImgProducto urls_imagenes={urls} />
        ) : (
          "—"
        );
      },
    },

    /* {
      accessorKey: "img",
      header: "Imagen",
      size: 200,
      Cell: ({ row }) =>
        row.original.urls_imagenes ? (
          <InfoImgProducto urls_imagenes={row.original.urls_imagenes} />
        ) : (
          "—"
        ),
    }, */
    {
      accessorKey: 'stock_actual',
      header: 'stock actual',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'costo_actual',
      header: 'costo actual',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'costo_compra',
      header: 'costo compra',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'costo_promedio',
      header: 'costo promedio',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'stock_maximo',
      header: 'stock maximo',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'stock_minimo',
      header: 'stock minimo',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'iva',
      header: 'iva',
      size: 150,
      Cell: ({ row }) => emptyCell(row.original.iva)
    },
    {
      accessorKey: 'marca_producto',
      header: 'marca producto',
      size: 200,
      Cell: ({ row }) => emptyCell(row.original.marca_producto)
    },

    {
      accessorKey: 'modelo_producto',
      header: 'modelo producto',
      size: 200,
      Cell: ({ row }) => emptyCell(row.original.modelo_producto)
    },
    {
      accessorKey: 'es_para_venta',
      header: 'es para venta',
      size: 200,
      filterVariant: 'select',
      filterSelectOptions: SI_NO_CHOICE,
      muiTableHeadCellFilterTextFieldProps: {
        select: true,
      },
      Cell: ({ row }) => (
        row.original.es_para_venta ? 'SI' : 'NO'
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'es_fibra',
      header: 'es fibra',
      size: 200,
      Cell: ({ row }) => (
        row.original.es_fibra ? 'SI' : 'NO'
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'es_utp',
      header: 'es utp',
      size: 200,
      Cell: ({ row }) => (
        row.original.es_utp ? 'SI' : 'NO'
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'es_ont',
      header: 'es ont',
      size: 200,
      Cell: ({ row }) => (
        row.original.es_ont ? 'SI' : 'NO'
      )
    },

    {
      ...cellNotFilter,
      accessorKey: 'Estado',
      header: 'estado',
      size: 200,
      Cell: ({ row }) => (
        <SwitchComponente
          estadoSwitch={row.original.estado}
          titulo={row.original.estado ? 'Activo' : 'Inactivo'}
          setEstadoSwitch={e => {
            setConfirmDialog({
              isOpen: true,
              title: 'Cambiar Estado',
              subtitle: '¿Está seguro que desea cambiar el estado de este registro?',
              onConfirm: () => {
                setConfirmDialogIsOpen(false)
                updateProducto.mutateAsync({
                  id: row.original.id_producto,
                  data: {
                    estado: e
                  } as any
                })
              },
            })
          }
          }
        />
      )
    }
  ], [])

  return {
    columns,
  };
};
